<script setup lang="ts">
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import { AuthLayout, DashLayout, ErrorLayout } from '@/pages/layouts'
import VPagePreloader from '@/shared/ui/VPagePreloader/ui/VPagePreloader.vue'

const route = useRoute()

/* Определение шаблона для страниц */
const layout = computed(() => {
  const layout = route.meta.layout || 'default'

  switch (layout) {
    case 'auth':
      return AuthLayout
    case 'error':
      return ErrorLayout
    default:
      return DashLayout
  }
})
</script>

<template>
  <VApp>
    <VPagePreloader />

    <component :is="layout">
      <RouterView />
    </component>
  </VApp>
</template>
